import * as React from 'react';
import { HOME_SLIDE_TIME, GetImageUrl } from '../core/Const';
import Slider from 'react-slick';
import { CMS } from '../shared/CMSData';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import {  getContentFronStorage } from '../utils/index';
// import { CoreComponentAjaxUtils } from '../utils/CoreComponentAjaxUtils';

export interface HomeBannerProps extends BaseComponentProps {
    lang: string;
}
export interface HomeBannerState extends BaseComponentState {
    bannerImage: CMS.CmsHomeBanner[];
    /**
     * flag lazy load passed atau tidak
     */
    lazyLoadPassed: boolean;

}
export class HomeBanner extends BaseComponent<HomeBannerProps, HomeBannerState> {

    imageURL: string = GetImageUrl();

    constructor(props: HomeBannerProps) {
        super(props);
        this.state = {
            bannerImage: [],
            lazyLoadPassed: false
        };
    }

    componentDidMount() {
        
        getContentFronStorage(this.props.lang, "CmsHomeBanner").then(
			(d: any[]) => {
                // this.setState({ data: d, requesting: false });
                this.setStateHelperAsync(
                    st => {
                        st.bannerImage = d;
                    }
                ).then(d1 => {
                    setTimeout(
                        () => {
                            this.setStateHelper(st2 => {
                                st2.lazyLoadPassed = true;
                            });
                        },
                        5000);
                }); 
			}).catch((exc) => { console.error('error: ', exc); }); 
    }

    render() {
        // console.log(this.state)
        // const AsyncComponent = this.state.selectCreatable ? Select.AsyncCreatable : Select.Async;
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        var settings = {
            dots: false,
            infinite: true,
            speed: HOME_SLIDE_TIME,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
        };
        let slide = [];
        let loop: number = 0;
        if (this.state.bannerImage.length === 0) {

            slide.push(
                <div key={'noimage'} className="swiper-slide" style={{ backgroundColor: '#eee', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                    <div className="container home-slider"  >{/**/}</div>
                </div>
            );
        } else {
            loop++;
            slide.push(
                <div key={`key-${loop}`} className="swiper-slide">
                    <div style={{ backgroundImage: `url(https://storage.googleapis.com/bali-hotel-images/promo_banner/HappyFamily.jpg)`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        <div className="container home-slider" >
                            <img src="https://storage.googleapis.com/bali-hotel-images/promo_banner/1-percent-deposit.png" style={{ width: '100%', marginTop: 140 }} />
                        </div>
                    </div>
                </div>
            );
            for (let x of this.state.bannerImage) {
                loop++;
                if (!x.lazyLoad || x.lazyLoad === 'N' || (x.lazyLoad === 'Y' && this.state.lazyLoadPassed)) {
                    let sty: React.CSSProperties = {
                        backgroundImage: `url("${x.imageUrl}")`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    };
                    slide.push(
                        <div  key={`key-${loop}`} className="swiper-slide">
                            <div style={sty}><div className="container home-slider"  /></div>
                        </div>
                    );

                }
            }
        }

        return (
            <div >
                <Slider {...settings} className="nopadding">
                    {slide}
                </Slider>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/home/HomeBanner.tsx